import {ChangeEvent, FC} from "react";
import DatePicker from "react-multi-date-picker";
import { KCTEventDto } from "../../types/contracts";
import {currencies, czechMonths, czechWeekDays} from "../../utils/constants";
import {formatCzechDates} from "../../utils/functions";

interface EventDetailsComponentProps {
    event: KCTEventDto;
    handleEventChange: (
        e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => void;
    handleDatesChange: (dates: any) => void;
}

const EventDetailsComponent: FC<EventDetailsComponentProps> = ({event, handleEventChange, handleDatesChange}) => {
    return (
        <div className="mb-6">
            <div className="mb-6">
                <label className="block mb-2 font-semibold" htmlFor="name">
                    Název události
                </label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={event?.name || ""}
                    onChange={handleEventChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    required
                />
            </div>
            <div className="mb-6">
                <label className="block mb-2 font-semibold" htmlFor="description">
                    Popisek údálosti
                </label>
                <textarea
                    id="description"
                    name="description"
                    value={event?.description || ""}
                    onChange={handleEventChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                />
            </div>
            <div className="mb-6">
                <label className="block mb-2 font-semibold" htmlFor="dates">
                    Dny události
                </label>
                <div className="w-full">
                    <DatePicker
                        multiple
                        id="dates"
                        value={event?.dates || []}
                        onChange={handleDatesChange}
                        months={czechMonths}
                        weekDays={czechWeekDays}
                        weekStartDayIndex={1}
                        containerClassName="w-full"
                        render={(value, openCalendar) => (
                            <input
                                readOnly
                                value={formatCzechDates(value)}
                                onFocus={openCalendar}
                                className="w-full p-2 border border-gray-300 rounded-md cursor-pointer"
                            />
                        )}
                    />
                </div>
            </div>
            <div className="mb-4 flex items-center">
                <input
                    type="checkbox"
                    id={`isCurrentEvent`}
                    name="isCurrentEvent"
                    checked={event?.isCurrentEvent || false}
                    onChange={handleEventChange}
                    className="mr-2"
                />
                <label className="font-semibold">
                    Je aktuální (nastavte pouze jednu akci!!)
                </label>
            </div>
            <div className="mb-6">
                <label className="block mb-2 font-semibold" htmlFor="accountNumber">
                    Číslo účtu
                </label>
                <input
                    type="text"
                    id="accountNumber"
                    name="accountNumber"
                    value={event?.accountNumber || ""}
                    onChange={handleEventChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    required
                />
            </div>
            <div className="mb-6">
                <label className="block mb-2 font-semibold" htmlFor="currency">
                    Měna
                </label>
                <select
                    id="currency"
                    name="currency"
                    value={event?.currency || ""}
                    onChange={handleEventChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    required
                >
                    <option value="" hidden>Vyberte měnu</option>
                    {currencies.map((currency) => (
                        <option key={currency} value={currency}>
                            {currency}
                        </option>
                    ))}
                </select>
            </div>
            <div className="mb-6">
                <label className="block mb-2 font-semibold" htmlFor="text">
                    Text platby
                </label>
                <input
                    type="text"
                    id="text"
                    name="text"
                    value={event?.text || ""}
                    onChange={handleEventChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    required
                />
            </div>
        </div>
    );
};

export default EventDetailsComponent;
